module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi6-cc6f6274712a9c231d244f2d60d3467e.png";